/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeGdriveEugeneTestDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-gdrive-eugene-test-dev" */ './utils').then(
			(m) => m.ForgeGdriveEugeneTestDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/icon' },
);

const LazyForgeGdriveEugeneTestDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "icon-forge-gdrive-eugene-test-dev-search-result" */ './utils'
		).then((m) => m.ForgeGdriveEugeneTestDevSearchResultIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-gdrive-eugene-test-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeGdriveEugeneTestDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeGdriveEugeneTestDevIconComponent />
	</Suspense>
);

export const ForgeGdriveEugeneTestDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeGdriveEugeneTestDevSearchResultIconComponent />
	</Suspense>
);
